import { ChevronHeader } from "@/components/chevron/ChevronHeader";
import { DomainSection } from "@/components/chevron/DomainSection";
import { upstreamDomains } from "@/data/chevron/upstreamDomains";
import { midstreamDomains } from "@/data/chevron/midstreamDomains";
import { downstreamDomains } from "@/data/chevron/downstreamDomains";
import Navbar from "@/components/Navbar";
import { Card, CardContent } from "@/components/ui/card";
import KnowledgeNetworkStats from "@/components/shared/KnowledgeNetworkStats";
const networkStats = {
  totalParticipants: 1625,
  activeContributors: 824,
  knowledgeBases: 1378,
  totalSolutions: 463,
  departments: [{
    name: "Upstream Operations",
    participants: 487
  }, {
    name: "Midstream Operations",
    participants: 342
  }, {
    name: "Downstream Operations",
    participants: 376
  }, {
    name: "Research & Development",
    participants: 245
  }, {
    name: "Corporate Strategy",
    participants: 175
  }]
};
const ChevronChannel = () => {
  return <div className="min-h-screen bg-white">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <ChevronHeader />
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Chevron Channel
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Explore Chevron's knowledge domains and contribute to our collective intelligence
          </p>
        </div>

        <Card className="mb-12 p-6">
          <CardContent className="p-0">
            <h2 className="text-xl font-semibold mb-4">Dashboard</h2>
            <KnowledgeNetworkStats {...networkStats} channelName="chevron" />
          </CardContent>
        </Card>
        
        <DomainSection title="Upstream" domains={upstreamDomains} titleColor="text-primary" />
        <DomainSection title="Midstream" domains={midstreamDomains} titleColor="text-primary" />
        <DomainSection title="Downstream" domains={downstreamDomains} titleColor="text-primary" />
      </div>
    </div>;
};
export default ChevronChannel;